<template>
  <div :class="[baseErrorClass]">
    <small
      class="is-invalid text-danger"
      v-if="
        typeof validate.required !== 'undefined' &&
        !validate.required &&
        validate.$error
      "
      >{{ label | capitalize }} is required</small
    >
    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.requiredIf !== 'undefined' &&
        !validate.requiredIf &&
        validate.$error
      "
      >{{ label | capitalize }} is required</small
    >
    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.email !== 'undefined' &&
        (!validate.email || !validate.isValidEmail) &&
        validate.$error
      "
      >Invalid {{ label | capitalize }} ID</small
    >
    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.isValidPassword !== 'undefined' &&
        !validate.isValidPassword &&
        validate.$error
      "
    >
      Please create password as per criteria mentioned below
    </small>
    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.isValidImage !== 'undefined' && !validate.isValidImage
      "
    >
      Please upload profile picture as per criteria mentioned below
    </small>
    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.sameAsPassword !== 'undefined' &&
        !validate.sameAsPassword &&
        validate.$error
      "
    >
      Password does not match, please try again
    </small>
    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.isValidPhoneNumber !== 'undefined' &&
        !validate.isValidPhoneNumber &&
        validate.$error
      "
    >
      Invalid {{ label | capitalize }}
    </small>
    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.numeric !== 'undefined' &&
        !validate.numeric &&
        validate.$error
      "
    >
      Invalid {{ label | capitalize }}
    </small>
    <small
      class="is-invalid text-danger"
      v-else-if="
        ((typeof validate.minLength !== 'undefined' && !validate.minLength) ||
          (typeof validate.maxLength !== 'undefined' && !validate.maxLength)) &&
        validate.$error
      "
    >
      {{ label | capitalize }}
      <span v-if="typeof validate.$params.maxLength === 'undefined'">
        must contain at least {{ validate.$params.minLength.min }}</span
      ><span v-else-if="typeof validate.$params.minLength === 'undefined'">
        cannot exceed {{ validate.$params.maxLength.max }}
      </span>
      <span v-else
        >must be between {{ validate.$params.minLength.min }} and

        {{ validate.$params.maxLength.max }}</span
      >
      characters
    </small>
    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.alphaNum !== 'undefined' &&
        !validate.alphaNum &&
        validate.$error
      "
    >
      Only alphabets and numbers are allowed
    </small>
    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.isValidVideoLink !== 'undefined' &&
        !validate.isValidVideoLink &&
        validate.$error
      "
    >
      Invalid Video Link
    </small>
    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.isValidRange !== 'undefined' &&
        !validate.isValidRange &&
        validate.$error
      "
    >
      Invalid {{ label | capitalize }}
    </small>
    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.url !== 'undefined' && !validate.url && validate.$error
      "
    >
      Invalid {{ label | capitalize }}
    </small>
    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.minValue !== 'undefined' &&
        !validate.minValue &&
        validate.$error
      "
    >
      {{ label | capitalize }} must be greater than or equal to

      {{ validate.$params.minValue.min }}
    </small>

    <small
      class="is-invalid text-danger"
      v-else-if="
        typeof validate.maxValue !== 'undefined' &&
        !validate.maxValue &&
        validate.$error
      "
    >
      {{ label | capitalize }} must be less than or equal to
      {{ validate.$params.maxValue.max }}
    </small>
  </div>
</template>

<script>
export default {
  props: {
    validate: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: "Field",
    },
    baseErrorClass: {
      type: String,
      required: false,
      default: "text-left",
    },
  },
};
</script>
